function sendWebTrekkInfo(wtDataLayer, wtSmartObj) {
  const wtSmart = wtSmartObj;

  wtSmart.init.set({
    trackId: wtDataLayer.trackId,
    trackDomain: wtDataLayer.trackDomain,
    domain: wtDataLayer.domain,
  });

  const customParameters = {
    name: wtDataLayer.contentId,
    parameter: {
      1: wtDataLayer.customParameter[1],
      2: wtDataLayer.customParameter[2],
      3: wtDataLayer.customParameter[3],
      4: wtDataLayer.customParameter[4],
      5: wtDataLayer.customParameter[5],
      6: wtDataLayer.customParameter[6],
      7: wtDataLayer.customParameter[7],
      8: wtDataLayer.customParameter[8],
      9: wtDataLayer.customParameter[9],
      10: wtDataLayer.customParameter[10],
      11: wtDataLayer.customParameter[11],
      12: wtDataLayer.customParameter[12],
      13: wtDataLayer.customParameter[13],
      14: wtDataLayer.customParameter[14],
      15: wtDataLayer.customParameter[15],
      16: wtDataLayer.customParameter[16],
      17: wtDataLayer.customParameter[17],
    },
    category: {
      1: wtDataLayer.contentGroup.kategorie_01 || wtDataLayer.contentGroup[1],
      2: wtDataLayer.contentGroup.hauptbereich_02 || wtDataLayer.contentGroup[2],
      3: wtDataLayer.contentGroup.tabReiter_03 || wtDataLayer.contentGroup[3],
      4: wtDataLayer.contentGroup.subReiter_04 || wtDataLayer.contentGroup[4],
      5: wtDataLayer.contentGroup.unterpunkt_05 || wtDataLayer.contentGroup[5],
      6: wtDataLayer.contentGroup.ebene5_06 || wtDataLayer.contentGroup[6],
      7: wtDataLayer.contentGroup.ebene6_07 || wtDataLayer.contentGroup[7],
    },
  };

  wtSmart.page.data.set(customParameters);

  if (wtDataLayer.user) {
    wtSmart.customer.data.add({
      email: wtDataLayer.user.email,
      firstName: wtDataLayer.user.firstname,
      lastName: wtDataLayer.user.lastname,
      birthday: wtDataLayer.user.birthday,
      gender: wtDataLayer.user.gender,
      telephone: wtDataLayer.user.phoneNumber,
    });
  }

  if (wtDataLayer.internalSearch) {
    wtSmart.page.data.add({
      search: wtDataLayer.internalSearch,
      numberSearchResults: wtDataLayer.numberSearchResults,
    });
  }

  wtSmart.track();
}

export default function trackPageView(customDataLayer = {}) {

  const mergedDataLayer = { ...window.wtDataLayer, ...customDataLayer };

  window.wtSmart = window.wtSmart || [];
  window.wtSmart.push((wtSmart) => sendWebTrekkInfo(mergedDataLayer, wtSmart));
}
